import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { baseQuery, createQueryString, getToken } from "../utility/helper";

export const sectionalApi = createApi({
  reducerPath: "sectionals",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getToken();
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["Sectionals"],
  endpoints: (builder) => ({
    createSectional: builder.mutation({
      query: (formData) => ({
        url: "/sectionals",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Sectionals"],
    }),

    updateSectional: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/sectionals/${id}`,
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: ["Sectionals"],
    }),

    deleteSectional: builder.mutation({
      query: (id) => ({ url: `/sectionals/${id}`, method: "DELETE" }),
      invalidatesTags: ["Sectionals"],
    }),

    getSectionals: builder.query({
      query: ({ page = 1, perPage = 10, buildingId = null, status = "" }) => {
        const params = {
          options: {
            query: {
              ...(buildingId && { buildingId }),
              ...(status && { status }),
            },
            page,
            limit: perPage,
            populate: [
              {
                dir: "buildings",
                path: "buildingId",
                select: "_id name",
              },
            ],
          },
        };

        const serializedParams = createQueryString(params);
        return `/sectionals?${serializedParams}`;
      },
      providesTags: ["Sectionals"],
    }),

    getSectionalById: builder.query({
      query: (id) => `/sectionals/${id}`,
      providesTags: (result, error, id) => [{ type: "Sectionals", id }],
    }),
  }),
});

export const {
  useGetSectionalsQuery,
  useCreateSectionalMutation,
  useUpdateSectionalMutation,
  useDeleteSectionalMutation,
  useGetSectionalByIdQuery,
} = sectionalApi;
